export const parcel = {
  name: `parcel`,
  sql: `
    SELECT cartodb_id, the_geom_webmercator, mun, cost, haz_wf, haz_fld, haz_eq2, haz_eq1, haz_damg, haz_tsu, haz_ls, haz_lev, content, haz_slr
    FROM solano_b03_hazards_x_parcel
  `,
  cartoCSS: `
  #layer {
    marker-width: ramp([cost], range(2, 25), jenks(5));
    marker-fill: ramp([cost], (#e498b4, #ca699d, #a24186, #6c2167), quantiles(4));
    marker-fill-opacity: 1;
    marker-allow-overlap: true;
    marker-line-width: 1;
    marker-line-color: #FFFFFF;
    marker-line-opacity: 1;
    marker-comp-op: src-over;
  }
  `,
  featureOverColumns: [
    'mun',
    'cost',
    'haz_wf',
    'haz_fld',
    'haz_eq2',
    'haz_eq1',
    'haz_damg',
    'haz_tsu',
    'haz_ls',
    'haz_lev',
    'haz_slr',
  ],
}

export const parcelCategories = {
  name: 'parcelCategories',
  type: 'Category',
  source: parcel.sql,
  field: 'mun',
  options: {
    limit: 100,
    operation: 'COUNT',
    operationColumn: 'cartodb_id'
  }
}

export const parcelCount = {
  name: 'parcelCount',
  type: 'Formula',
  source: parcel.sql,
  field: 'cost',
  options: {
    operation: 'COUNT',
    operationColumn: 'cost'
  }
}

export const parcelCost = {
  name: 'parcelCost',
  type: 'Formula',
  source: parcel.sql,
  field: 'cost',
  options: {
    operation: 'SUM',
  }
}

export const parcelContent = {
  name: 'parcelContent',
  type: 'Formula',
  source: parcel.sql,
  field: 'content',
  options: {
    operation: 'SUM',
  }
}